import React from 'react'
import { FirstTimeInvestorPresenter } from './first-time-investor-presenter'

const FirstTimeInvestor = () => {
  return <FirstTimeInvestorPresenter />
}

export { FirstTimeInvestor }
